export class LocationInfo {
    constructor(data) {
        if (!data)
            return;
        this.IpAddress = data.ipAddress || data.IpAddress;
        this.ContinentCode = data.continentCode || data.ContinentCode;
        this.CountryCode = data.countryCode || data.CountryCode;
        this.State = data.stateProv || data.StateProv;
        this.City = data.city || data.City;
        this.Zip = data.zipCode || data.ZipCode || data.Zip;
        this.Lat = data.latitude || data.Latitude;
        this.Long = data.longitude || data.Longitude;
        this.IsEuMember = data.isEuMember || data.IsEuMember;
    }
}
